import { render } from "./new.vue?vue&type=template&id=233f5b51&scoped=true"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"

import "@/assets/custom-outside.css?vue&type=style&index=0&id=233f5b51&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233f5b51"]])

export default __exports__